/**
 * Represents common breakpoints at which a component should render inline
 */
var Inline;
(function (Inline) {
    Inline["never"] = "never";
    Inline["always"] = "always";
    Inline["at512"] = "at-512";
    Inline["at768"] = "at-768";
    Inline["at960"] = "at-960";
    Inline["at1280"] = "at-1280";
})(Inline || (Inline = {}));

export { Inline };
